import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@material-ui/lab';

const MessageInfo = props => {
    const { type= 'info', text } = props
    return (
        <div>
            <Alert severity={type}>{text}</Alert>
        </div>
    );
};

MessageInfo.propTypes = {
    text: PropTypes.string.isRequired,
};

export default MessageInfo;